import { useState } from "react";
import { getAllDataCodename, useCommonComponentContext } from "@maysoft/common-component-react";

import useStrings from "../../useStrings";
import Helpers from "../../../commons/helpers";
import MessageTemplateService from "../../../services/message/MessageTemplate.service";
import { ICodename } from "../../../commons/interfaces";
import { MessageTemplateCaseCode, MessageTemplateType } from "../../../constants/enums";

const getMessageCaseGroupCode = (type: MessageTemplateType) => {
    if (type === MessageTemplateType.Email) return MessageTemplateCaseCode.Email;
    if (type === MessageTemplateType.SMS) return MessageTemplateCaseCode.SMS;
    if (type === MessageTemplateType.Notification) return MessageTemplateCaseCode.Notification;
};

const useSelectData = ({ tenantCode, serviceCode, circleServiceCode }: { tenantCode?: string, serviceCode?: string, circleServiceCode?: string }) => {
    const Strings = useStrings();

    const { userInfo, onError } = useCommonComponentContext();

    const [caseCodeList, setCaseCodeList] = useState<ICodename[]>([]);
    const [messageTemplateList, setMessageTemplateList] = useState<ICodename[]>([]);

    const messageTemplateTypeData = [
        {
            code: MessageTemplateType.Email,
            name: Strings.Common.EMAIL,
        },
        {
            code: MessageTemplateType.SMS,
            name: Strings.Common.SMS,
        },
        {
            code: MessageTemplateType.Notification,
            name: Strings.Common.NOTIFICATION,
        },
    ];

    const getAllCaseCode = async (type: MessageTemplateType) => {
        try {
            const value = getMessageCaseGroupCode(type);

            const result = await getAllDataCodename({
                group: [value],
                serviceCode: circleServiceCode,
                organizationId: userInfo?.userProfile?.organizationId || "0",
            });

            setCaseCodeList(result.get(value) || []);
        } catch (error) {
            const e = Helpers.renderExceptionError(error);
            onError(e);
        }
    };

    const getAllMessageTemplate = async (type: MessageTemplateType) => {
        try {
            const req = {
                type: type,
                tenantCode: tenantCode,
                serviceCode: serviceCode,
                organizationId: userInfo?.userProfile?.organizationId || "0",
            };

            const result = await MessageTemplateService.getAll(Helpers.handleFormatParams(req));

            const newData = result.map((item) => ({
                code: item.templateCode,
                name: item.templateName,
                detail: {
                    ...item,
                },
            }));

            setMessageTemplateList(newData);
        } catch (error) {
            setMessageTemplateList([]);
            const e = Helpers.renderExceptionError(error);
            onError(e);
        }
    };

    return {
        caseCodeList,
        messageTemplateList,
        messageTemplateTypeData,
        getAllCaseCode,
        getAllMessageTemplate,
    };
};

export default useSelectData;
